
<template>
             <!--会议展览-->
             <div class="pageCon">
               <div class="main">
                   <div class="topTibar clearfix">
                        <template v-if="ListType==2">
                            <div class="tibar">
                               <h2>科学普及</h2>
                               <span>Science popularization</span>
                            </div>
                        </template>
                        <template v-else>
                         <div class="tibar">
                               <h2>会议展览</h2>
                               <span>Convention and exhibition</span>
                         </div>
                        </template>
                     </div>
                    <div class="homeExhibitionList clearfix">
                        <ul>
                          <template v-for="item in list">
                            <li class="clearfix" :key="item.id">
                                    <router-link :to="{ name:ListType==2?'popsciactivitydetail':'intlactivitydetail',params:{id:item.id} }">
                                    <div class="img">
                                      <img :src="item.imgUrl" alt="">
                                    </div>
                                    <div class="info">
                                        <div class="time">{{item.timeStr}}</div>
                                        <div class="title">
                                            {{item.title}}
                                        </div>
                                    </div>
                                    </router-link>
                            </li>
                            </template>
                        </ul>
                    </div>
                    <div class="viewmore">
                        <router-link :to="{name:ListType==2?'popsciactivity':'meeting'}"><span>查看更多</span></router-link>
                    </div>
                </div>
               </div>
              <!---->
</template>

<script>
export default {
  data(){
    return{
        list:[],
        total:0,
    }
  },
  props:{
    id:{},
    ListType:{}
  },
  created(){
    this.GetList();
  },
  components:{
    
  },
  methods:{

    GetList() {
            var url = "/pageapi/Activity/GetList";
            this.$http.post(url,{pagesize: 4,ListType:this.ListType}).then(function(res){
                if (res.data.status==1){
                    this.list=res.data.ds;
                    this.total=res.data.total;
                }
            }.bind(this)).catch(function(){
            });
        },

  }
}
</script>
